export default __webpack_public_path__ + "4c1f8f99ff6367b102c79cf5a3adeade.png";